import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const EnvelopeOutlinedSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.64045 6.50514C2.13289 7.30961 1.8 8.64899 1.8 11V13C1.8 15.9003 2.3066 17.261 3.02279 17.9772C3.73898 18.6934 5.09972 19.2 8 19.2H16C18.9003 19.2 20.261 18.6934 20.9772 17.9772C21.6934 17.261 22.2 15.9003 22.2 13V11C22.2 8.64896 21.8671 7.30958 21.3595 6.5051L12 14.1629L2.64045 6.50514ZM19.9273 5.35118C19.0975 5.01019 17.8681 4.8 16 4.8H8C6.13184 4.8 4.90244 5.01019 4.07262 5.3512L12 11.8372L19.9273 5.35118ZM0 11C0 5 2 3 8 3H16C22 3 24 5 24 11V13C24 19 22 21 16 21H8C2 21 0 19 0 13V11Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const EnvelopeOutlinedSize24 = hoc(forwardRef(EnvelopeOutlinedSize24Component), 'EnvelopeOutlinedSize24');

export { EnvelopeOutlinedSize24 as default };
//# sourceMappingURL=EnvelopeOutlinedSize24.js.map
